import React, { useState, useEffect, useContext, useRef} from 'react';
import * as S from './styles';
import * as T from './types';
import C from '@assets/themes/colors';
import { useDispatch, useSelector } from 'react-redux';
import selectors from '@state/selectors';
import { flatten } from 'lodash';
import { IDSConfig, IBrandDefinition, IBrandImageType } from '@state/dsconfig/types';
import { IBrandImage, IOemFilter } from '@state/brandsImages/types';
import Button from '@components/Button';
import {getQueryTypes, getOEMQueryTypes, getQueryYearModel} from '@utils/searches';
import { getOEMDefault } from '@utils/brand';
import ImagesList from '../ImagesList';
import Filters from '../Filters'
import actions from '@state/actions';
import Chips from '@components/Chips';
import FilterCheck from '@components/Filter';
import MoreChips from '@routes/private/Templates/components/ListTemplate/components/MoreChips';
import { Context } from "routes/private/Editor/Context";
import { IBrandImageSection } from '@utils/DOIgnition/BrandsContext';
import { IPickerSearchImagesProperties } from "routes/private/Editor/types";

const OtherImages: React.FC<T.IProps> = (props) => {
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedData, setSelectedData] = useState<IBrandImage | undefined>(undefined);
  const [selectedIndex, setSelectedIndex] = useState<number | undefined>(undefined);   
  const [imagesList, setImagesList] = useState<IBrandImage[]>([]);
  const [allowClean, setAllowClean] = useState<boolean>(true);
  const [selectedIndexes, setSelectedIndexes] = useState<number[]>([]);
  const [selectedFilters, setSelectec]= useState<T.ISelectedFilter[]>([]);
  const [allFilters, setAllFilters]= useState<string[]>([]);
  const [commonAssets, setCommonAssets]= useState<T.ICommonAssets>({show: false, active: false, id: "'"});

  const [init, setInit] = useState<boolean>(true);

  const {entityInformation, editorStatus} = useContext(Context);
  const stateRef = useRef<boolean>();
  const loadMore = useRef<boolean>(true);
  const loadOemImages = useRef<boolean>(false);
  const page = useRef<number>(0);
  const pageSize = useRef<number>(5);
  const start = useRef<number|undefined>(undefined);
  const dispatch = useDispatch();
  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
  const section = `${props.category}s` as IBrandImageSection;
  const types = dsConfig.brandsConfig[section]?.types ?? [];

  const brandImagesFilters: IOemFilter[] = useSelector(
    props.category==="logo" 
    ? selectors.brandsImages.getBrandImagesFiltersLogos
    :props.category==="stock" 
      ? selectors.brandsImages.getBrandImagesFiltersStocks
      : selectors.brandsImages.getBrandImagesFiltersBackgrounds);

  const loadFromBrand = editorStatus?.currentPicker==="BrandLibrary";
    
  const fetchImagesList: IBrandImage[] = useSelector(selectors.brandsImages.getBrandImages);
  const searchResultscounterSearch: any = useSelector(selectors.brandsImages.getCounterBrandImagesSearch);

  const fetchFilters = () => {    
    let query = createQuery(undefined);
    return new Promise((resolve, reject) => {      
      dispatch(actions.brandsImages.fetchBrandImagesFilters(props.category, query, (result, error) => {         
        setIsLoading(false);     
        if (error) reject(error)
        else {          
          resolve(result)}
      }))
    });
  }

  const fetchImages = () => {    
    let query = createQuery();
    return new Promise((resolve, reject) => {      
      dispatch(actions.brandsImages.fetchBrandImages(query, start.current??0, pageSize.current, undefined, (result, error) => { 
        setIsLoading(false);     
        if (error) reject(error)
        else {          
          resolve(result)}
      }))
    });
  }

  const fetchCounter = () => {    
    let query = createQuery();
    return new Promise((resolve, reject) => {      
      dispatch(actions.brandsImages.fetchCounterBrandImages(`?filter=${query}`, 'search',  (result, error) => {      
        if (error) reject(error)
        else {       
          resolve(result)}
      }))
    });
  }

  const createQuery = (start?: number) => {
    
    let filtersQuery = `c.status='ACTIVE' and c.imageType='${props.category.toLocaleUpperCase()}S' `;
    let order = "c.updateDate DESC";
    let oemFilters =  selectedFilters.filter(filter => filter.id==="oem" && filter.value!==null);
    let typeFilters =  selectedFilters.filter(filter => filter.id!=="oem" && filter.id!=="theme" && filter.id!=="subtheme" && filter.value!==null);
    let themesFilters =  selectedFilters.filter(filter => (filter.id==="theme" || filter.id==="subtheme") && filter.value!==null);
    if (loadFromBrand) {
      if (editorStatus.pickerProperties) {
        let pickerProperties : IPickerSearchImagesProperties = (editorStatus.pickerProperties as IPickerSearchImagesProperties);
        if (pickerProperties?.search) filtersQuery+= `and udf.searchMetadataBrandImage("${pickerProperties?.search}", c)`;
      }
    }

    //OEM -> brandId in ("id oem1", "id oem2")
    if (oemFilters.length>0 && typeFilters.length==0) {
      filtersQuery+= `and c.brandId IN (`;
      oemFilters.forEach((filter, idx) => {
          filtersQuery+=`'${filter.value}'`
          if (idx < oemFilters.length-1)filtersQuery+= `,`;
      })
      filtersQuery+= `)`;
    } else if (oemFilters.length>0 && typeFilters.length>0) { 
      filtersQuery+= `and (`;
      oemFilters.forEach((filter, idx) => {
          filtersQuery+=`( c.brandId IN ('${filter.value}') `
          let oemInfo =  brandImagesFilters?.find((itemAllow: IOemFilter) =>  itemAllow.id===filter.value);
          if (oemInfo) filtersQuery+= getOEMQueryTypes(typeFilters, oemInfo);
          filtersQuery+=`)`
          if (idx < oemFilters.length-1)filtersQuery+= ` or `;
      })
      filtersQuery+= `)`;
    } else if (typeFilters.length>0) filtersQuery+= getQueryTypes(typeFilters);
    if (themesFilters.length>0) filtersQuery+= getQueryTypes(themesFilters, true);  
    filtersQuery+= getQueryYearModel(selectedFilters, 'year');  
    filtersQuery+= getQueryYearModel(selectedFilters, 'model');        
    return `${filtersQuery}&orderby=${order}`; 
  }

  const loadImages = async(startValue?:number) => {    
    if (loadMore.current) {
      start.current = startValue;
      if (!start) {
        var myDiv = document.getElementById('infinite-scroll-all-vehicles');
        if (myDiv) myDiv.scrollTop = 0;
      }
      setIsLoading(true);
      await fetchImages();
    }
  }

  const loadBrandFilters = async ()=>{   
    await fetchFilters();
  }


  const setDefaultCommon=()=>{    
    const commonOem = dsConfig.brands.find(oemItem => oemItem.useAsCommon);
    const pickerProperties = editorStatus.pickerProperties as IPickerSearchImagesProperties;      
    if (commonOem)
    {
      setCommonAssets({show: true, id: commonOem?.id ?? '', active: !props.showDescription ? true : !pickerProperties?.search});   
    }
    else
    {
      setCommonAssets({show: false, active: false, id: "'"});    
    }
  }

  const setDefaultOEM = () => {              
      let oemDefault: IBrandDefinition|undefined =  getOEMDefault(entityInformation, dsConfig);;
      let oem : IBrandDefinition|undefined =dsConfig.brands.find((oemItem: IBrandDefinition) => oemItem.id===oemDefault?.id);
      let pickerProperties : IPickerSearchImagesProperties = (editorStatus.pickerProperties as IPickerSearchImagesProperties);                  

      let defaultselec: T.ISelectedFilter[] = [];

      if (oem && !pickerProperties?.search){
        let findOem: IOemFilter|undefined = brandImagesFilters.find((oemFilter: IOemFilter) => oemFilter.id===oem?.id)
        if (findOem) 
            defaultselec.push({id: "oem", value:oem.id, text: oem.name})          
        if (commonAssets.id!= oem.id && commonAssets.active)
            defaultselec.push({id:"oem", value:commonAssets.id,text: "Common"})
      }        
      else
      {
        if (commonAssets.active)
          defaultselec.push({id:"oem", value:commonAssets.id,text: "Common"})
      }
      setInit(false);
      setSelectec(defaultselec);
  }






  useEffect(() => {
    if(fetchImagesList) {
      if (start.current) setImagesList([...imagesList, ...fetchImagesList]);
      else setImagesList(fetchImagesList);  
      if (fetchImagesList.length<pageSize.current) loadMore.current=false;
    }
  }, [fetchImagesList]);

  useEffect(() => {
    let divList = document.getElementById('content-container');
    if (divList) {
      let cols = Math.round((divList.clientWidth - 116)/230);
      let rows = Math.round((divList.clientHeight - 188)/170);
      pageSize.current = ((rows+1) * cols);
    }         
    reloadCounter();
  }, []);

  


  useEffect(() => {    
    if (brandImagesFilters && init) {
      setDefaultCommon();        
    }
  }, [brandImagesFilters])



  useEffect(() => {
    if (stateRef) stateRef.current = allowClean;
  }, [allowClean]);

  useEffect(() => {
    if (brandImagesFilters && !init)
    {    
      loadMore.current=true;
      page.current=0;          
      loadImages();          

      setAllFilters(flatten(selectedFilters.filter(filter => (filter.text!=="Common") ).map(type => { return type.text })));
      reloadCounter();   

    } 
    else if (init)
      loadBrandFilters();
    
}, [selectedFilters]);

  useEffect(()=>{    
    
    if (brandImagesFilters && init )
      setDefaultOEM();
  },[commonAssets])

  useEffect(()=>{    
    setInit(true);        
    loadOemImages.current =false;
    setImagesList([])      
    setSelectec([]);    
  },[props.category])


  const reloadCounter = () => {
    if (editorStatus.pickerProperties) {
      const run = async () => { await fetchCounter();
      }
      run();
    }
  }

  const getDisabled =  () => {
    return selectedData == undefined
  }
  
  const handleScroll = async(e: any) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      loadImages(page.current + pageSize.current); 
      page.current = (page.current+pageSize.current); 
    }
  }
  
  const handleSelectFilter = (add: boolean, id: string, value: string, text: string) => {   

    if (!add && id=="type" && selectedFilters.length>0) {
      let newSelected = selectedFilters.filter(filter => {
        if (filter.id==="subtype") {
          let typeDelete = types[0].types?.find((typeItem:IBrandImageType) => typeItem?.value=== value);
          if (typeDelete) {
            let search = typeDelete.types?.find((subType:IBrandImageType) => subType?.value=== filter?.value);
            if (!search) return filter;
          }
        } else if (filter.value!=value) return filter;
      });
      setSelectec(newSelected);
    } else if (add) setSelectec([...selectedFilters, {id: id, value:value, text: text}]);
    else setSelectec(selectedFilters.filter(filter => !(filter.id===id && filter.value===value)));
  }

  const handleRemoveChip = (index: number) => setSelectec(selectedFilters.filter(filter => filter.text!==allFilters[index]));
  
  const handleSelectCommon = (value: string) => {    

    handleSelectFilter(!commonAssets.active, 'oem',  commonAssets.id, value);
    setCommonAssets({...commonAssets, active: !commonAssets.active});
  }

  return (
    <>   
      <S.Content>
        {
          (props.showDescription??true) &&
        <S.Description>
          {props.category==="background" 
          ? `Filter to find the image you are looking for `
          :`Search or filter to find the image you are looking for  `}
        </S.Description>
        } 
        {editorStatus.pickerProperties && <S.SearchText>
            {searchResultscounterSearch?.counter ? `${searchResultscounterSearch.counter} Result${searchResultscounterSearch.counter>1 ? 's':''} for “${(editorStatus.pickerProperties as IPickerSearchImagesProperties).search}”` : `...`}
        </S.SearchText> }
        <S.LoadContainer>
            <S.Container>
              <S.Row>
                <Filters category={props.category} 
                onSelect={(add: boolean, id: string, value: string, text: string) => handleSelectFilter(add, id, value, text)} 
                allFilters={allFilters}
                selectedFilters={selectedFilters}
                brandImagesFilters={brandImagesFilters}/>
                <S.ChipsCol>
                    <Chips items={allFilters.slice(0, 5)} handleRemove={handleRemoveChip}/>
                </S.ChipsCol>
                <S.MoreChipsCol><S.Absolute>
                {(allFilters.length>5) && <MoreChips styleLabel={{color: '#204078'}} chips={allFilters.slice(5, allFilters.length)} handleRemove={(index: number)=>handleRemoveChip(index)} handleRemoveAlll={()=> {setSelectec([]); loadMore.current=true;}} nchips={5}/>}
                </S.Absolute></S.MoreChipsCol>
                {commonAssets.show &&
                <FilterCheck 
                  key={`common-toggle`}
                  label={'Common'} 
                  type={''} 
                  onChange={(value:any, type:string, add:boolean)=> handleSelectCommon(value)}
                  checked={commonAssets.active}
                  rootStyle={{position : 'absolute', right: 0}}/>}
              </S.Row>  
            </S.Container>                         
        </S.LoadContainer>
        
        <ImagesList
          onScroll={(e:any)=>handleScroll(e)}
          imagesList={selectedFilters.filter(f => f.id==="oem" && f.value !== null).length === 0 ? [] : imagesList}
          isLoading={isLoading}
          setAllowClean={setAllowClean}
          setSelectedData={setSelectedData}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          selectedIndexes={selectedIndexes}
          category={props.category}
          searching = {searchResultscounterSearch?.counter }
          updateImagesList={loadFromBrand ? setImagesList : undefined}
          loadFromBrand={loadFromBrand}
        />

      </S.Content>
      <S.ActionsContainer>
        <S.Action>
          <Button
            label="CANCEL"
            style={{
              width: '112px',
              marginRight: 12,
              backgroundColor: "transparent",
              border: `1px solid ${C.BLUE}`,
              hoverBackgroundColor: `${C.BLUE}22`,
            }}
            labelStyle={{ color: C.BLUE }}
            onClick={() => {props.setOpen(false)}}
            disabled={isSaving ? true : false}
          />
        </S.Action>
        <S.Action>
          <Button
            label={"ADD"}
            style={{
              width: '112px',
              backgroundColor: true ? C.BLUE : C.GENERIC_GRAY,
              flexGrow: 0,
              hoverBackgroundColor: true ? `${C.BLUE}AA` : `${C.GENERIC_GRAY}AA`,
            }}
            onClick={() => {props.onSelect(selectedData) }}
            disabled={getDisabled()}
            loading={props.loadingImage}
          />
        </S.Action>
      </S.ActionsContainer>   
    </>
  );
}

export default OtherImages;